import {
  deleteAdminV1OrgStoresId,
  getAdminV1OrgStores,
  getAdminV1MetaTimezones,
  getAdminV1OrgStoresId,
  getAdminV1OrgStoresIdReadiness,
  patchAdminV1OrgStoresId,
  postAdminV1OrgStores,
  postAdminV1StoresStoreIdSearchReindex,
  postAdminV1StoresStoreIdSeoIndexnowKey,
  type IndexNowKey,
  type PatchAdminV1OrgStoresIdBody,
  type PostAdminV1OrgStoresBody,
  type ReindexResponse,
  type Store,
  type StoreReadiness,
} from '@nucleus-commerce/api-client/admin';

/** Stores the membership covers; a bounded `{ items }` list, no cursor. */
export const storesApi = {
  list: (): Promise<Store[]> => getAdminV1OrgStores().then((r) => r.items),
  get: (id: string): Promise<Store> => getAdminV1OrgStoresId({ id }),
  create: (body: PostAdminV1OrgStoresBody): Promise<Store> => postAdminV1OrgStores(body),
  update: (id: string, body: PatchAdminV1OrgStoresIdBody): Promise<Store> =>
    patchAdminV1OrgStoresId({ id }, body),
  remove: (id: string): Promise<void> => deleteAdminV1OrgStoresId({ id }),
  /** 202: the worker rebuilds the store's shopper search index. */
  reindexSearch: (storeId: string): Promise<ReindexResponse> =>
    postAdminV1StoresStoreIdSearchReindex({ storeId }),
  /** Creates or rotates the IndexNow key; the old key stops working at once. */
  /** Blockers stop activation (409 STORE_NOT_READY unless forced); warnings only inform. */
  readiness: (id: string): Promise<StoreReadiness> => getAdminV1OrgStoresIdReadiness({ id }),
  /** Zones the backend accepts; Intl alone lists legacy ids and misses UTC on some engines. */
  timezones: (): Promise<string[]> => getAdminV1MetaTimezones().then((r) => r.items),
  rotateIndexNowKey: (storeId: string): Promise<IndexNowKey> =>
    postAdminV1StoresStoreIdSeoIndexnowKey({ storeId }),
};
